import { useContext } from 'react';

import { PubNubStateContext, PubNubDispatchContext } from 'community/providers/PubNubProvider';

export const usePubNubState = () => useContext(PubNubStateContext);
export const usePubNubDispatch = () => useContext(PubNubDispatchContext);
